import { render, staticRenderFns } from "./MainSliderForm.vue?vue&type=template&id=627354c4&"
import script from "./MainSliderForm.vue?vue&type=script&lang=js&"
export * from "./MainSliderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports